const timeCodes = new Set([
  "delivery_time_required", "delivery_time_invalid", "delivery_time_expired", "delivery_slot_unavailable",
  "asap_unavailable", "scheduled_time_unavailable", "asap_authority_unavailable", "asap_context_changed",
  "asap_window_mismatch", "asap_cart_changed", "capacity_full", "date_capacity_full", "store_closed",
]);
const locationCodes = new Set([
  "context_invalid", "fulfillment_method_required", "delivery_disabled", "pickup_disabled", "branch_unavailable",
  "branch_offline", "branch_hidden", "delivery_area_unavailable", "branch_delivery_area_mismatch",
  "branch_delivery_disabled", "pickup_branch_required", "branch_pickup_disabled", "country_context_mismatch",
  "car_pickup_unavailable", "delivery_not_applicable", "map_pin_coordinates_invalid",
  "map_pin_validation_unavailable", "map_pin_delivery_area_mismatch",
]);

export const getCartValidationNotice = (error, language = "english") => {
  const ar = language === "arabic";
  const code = `${error || ""}`.trim();
  if (timeCodes.has(code)) {
    const capacity = ["capacity_full", "date_capacity_full"].includes(code);
    return {
      contextAction: true, actionLabel: ar ? "اختيار الوقت" : "Choose time",
      title: capacity ? ar ? "الوقت المختار ممتلئ" : "Your selected time is fully booked"
        : ar ? "اختر وقتًا متاحًا لطلبك" : "Choose an available time for your order",
      message: ar ? "منتجاتك محفوظة. اختر وقت توصيل أو استلام متاحًا للمتابعة."
        : "Your items are saved. Choose an available delivery or pickup time to continue.",
    };
  }
  if (locationCodes.has(code)) return {
    contextAction: true, actionLabel: ar ? "تغيير خيارات الطلب" : "Change order options",
    title: code === "delivery_not_applicable" ? ar ? "هذه المنتجات لا تحتاج إلى توصيل" : "These items do not support delivery"
      : ar ? "راجع مكان وطريقة الطلب" : "Check your order location and method",
    message: code === "delivery_not_applicable" ? ar ? "اختر الاستلام أو احذف المنتجات غير المناسبة من السلة."
      : "Choose pickup, or remove the unsuitable items from your cart."
      : ar ? "طريقة الطلب أو المنطقة أو الفرع المختار غير متاح لهذا الطلب. غيّر خيارات الطلب للمتابعة."
      : "The selected method, area, or branch isn’t available for this order. Update your order options to continue.",
  };
  return {
    contextAction: false, actionLabel: ar ? "تحديث السلة" : "Refresh cart",
    title: code === "remove_unavailable" ? ar ? "تعذرت إزالة المنتج" : "The item couldn’t be removed"
      : ar ? "تعذر تأكيد السلة" : "We couldn’t confirm your cart",
    message: ar ? "منتجاتك محفوظة. لم نتمكن من تأكيد التوفر والسعر. حدّث السلة للمحاولة مجددًا."
      : "Your items are saved. We couldn’t confirm availability and pricing. Refresh the cart to try again.",
    reference: code && code !== "validation_unavailable" ? code : null,
  };
};
